export const idiomsAndExpressions = [
  {
    word: "Break the ice",
    image: "https://images.unsplash.com/photo-1516030651049-556ebc79c121",
    definition: "To start a conversation in a social setting",
    example: "He told a joke to break the ice at the party.",
    synonyms: ["start a conversation", "ease the tension"]
  },
  {
    word: "Hit the nail on the head",
    image: "https://images.unsplash.com/photo-1598819651063-02467124967f",
    definition: "To be exactly right about something",
    example: "You hit the nail on the head with your answer.",
    synonyms: ["be spot on", "get it right"]
  },
  {
    word: "Under the weather",
    image: "https://images.unsplash.com/photo-1597764690063-d8647c3f675d",
    definition: "Feeling sick or unwell",
    example: "I’m feeling a bit under the weather today.",
    synonyms: ["ill", "not feeling well"]
  },
  {
    word: "Let the cat out of the bag",
    image: "https://images.unsplash.com/photo-1555685812-4b943f1cb0eb",
    definition: "To reveal a secret by mistake",
    example: "He let the cat out of the bag about the surprise party.",
    synonyms: ["spill the beans", "reveal the secret"]
  },
  {
    word: "Bite the bullet",
    image: "https://images.unsplash.com/photo-1617837912076-08d4b839b3ba",
    definition: "To do something painful or unpleasant that is unavoidable",
    example: "I had to bite the bullet and take the exam.",
    synonyms: ["face the music", "deal with it"]
  },
  {
    word: "Cost an arm and a leg",
    image: "https://images.unsplash.com/photo-1628586708598-951d57bb95e2",
    definition: "Very expensive",
    example: "The repair cost an arm and a leg!",
    synonyms: ["very costly", "outrageously expensive"]
  },
  {
    word: "A piece of cake",
    image: "https://images.unsplash.com/photo-1505253210343-49cfb3f76ff9",
    definition: "Very easy",
    example: "The test was a piece of cake.",
    synonyms: ["very easy", "simple"]
  },
  {
    word: "Once in a blue moon",
    image: "https://images.unsplash.com/photo-1520391020283-1ec9d8d9c5d7",
    definition: "Very rarely",
    example: "She visits us once in a blue moon.",
    synonyms: ["rarely", "not often"]
  },
  {
    word: "The ball is in your court",
    image: "https://images.unsplash.com/photo-1579546929518-9e396f3cc809",
    definition: "It’s your decision or responsibility to do something",
    example: "I've done all I can. Now the ball is in your court.",
    synonyms: ["your turn", "your move"]
  },
  {
    word: "Let sleeping dogs lie",
    image: "https://images.unsplash.com/photo-1560807707-8cc77767d783",
    definition: "Don’t bring up old conflicts",
    example: "Don’t talk about that again—let sleeping dogs lie.",
    synonyms: ["avoid past issues", "don’t reopen arguments"]
  },
  {
    word: "Burn the midnight oil",
    image: "https://images.unsplash.com/photo-1540238161969-50f91c34a6e1",
    definition: "To stay up late working or studying",
    example: "She burned the midnight oil before the exam.",
    synonyms: ["stay up late", "work late"]
  },
  {
    word: "Call it a day",
    image: "https://images.unsplash.com/photo-1573495804688-9b74876bfe26",
    definition: "To stop working for the day",
    example: "I'm tired—let's call it a day.",
    synonyms: ["stop working", "finish"]
  },
  {
    word: "Bend over backwards",
    image: "https://images.unsplash.com/photo-1533670809338-4fd2341fc70d",
    definition: "Try very hard to help someone",
    example: "She bent over backwards to help her friend.",
    synonyms: ["go the extra mile", "do everything possible"]
  },
  {
    word: "By the book",
    image: "https://images.unsplash.com/photo-1553729459-efe14ef6055d",
    definition: "Follow the rules exactly",
    example: "The police officer does everything by the book.",
    synonyms: ["follow the rules", "stick to procedure"]
  },
  {
    word: "On the fence",
    image: "https://images.unsplash.com/photo-1503919545880-b4fd5d0f13dd",
    definition: "Undecided about something",
    example: "I’m on the fence about which course to take.",
    synonyms: ["undecided", "not sure"]
  },
  {
    word: "Add fuel to the fire",
    image: "https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0",
    definition: "Make a bad situation worse",
    example: "His comments just added fuel to the fire.",
    synonyms: ["make worse", "provoke more"]
  },
  {
    word: "Throw in the towel",
    image: "https://images.unsplash.com/photo-1555685812-4b943f1cb0eb",
    definition: "To give up or admit defeat",
    example: "He finally threw in the towel and quit.",
    synonyms: ["give up", "surrender"]
  },
  {
    word: "In hot water",
    image: "https://images.unsplash.com/photo-1600275668771-b13d58bb36d2",
    definition: "In trouble",
    example: "He’s in hot water with his boss.",
    synonyms: ["in trouble", "in a bad situation"]
  },
  {
    word: "Hit the sack",
    image: "https://images.unsplash.com/photo-1503264116251-35a269479413",
    definition: "To go to bed",
    example: "I’m really tired—I’m going to hit the sack.",
    synonyms: ["go to sleep", "turn in"]
  },
  {
    word: "Kick the bucket",
    image: "https://images.unsplash.com/photo-1500217052183-bc01eee1fd0d",
    definition: "To die (informal)",
    example: "The old man finally kicked the bucket.",
    synonyms: ["die", "pass away"]
  },
  {
    word: "Cry over spilled milk",
    image: "https://images.unsplash.com/photo-1585110396000-bd1c9d57d2c3",
    definition: "To be upset about something that can't be changed",
    example: "It's no use crying over spilled milk.",
    synonyms: ["don't dwell", "move on"]
  },
  {
    word: "Pull someone’s leg",
    image: "https://images.unsplash.com/photo-1536305030012-3a2f45627b91",
    definition: "To joke or trick someone",
    example: "Relax, I was just pulling your leg.",
    synonyms: ["tease", "joke"]
  },
  {
    word: "Cut corners",
    image: "https://images.unsplash.com/photo-1616627454187-dc79cd52c31e",
    definition: "Do something cheaply or poorly to save time or money",
    example: "They cut corners when building the house.",
    synonyms: ["save effort", "do something quickly"]
  },
  {
    word: "Jump the gun",
    image: "https://images.unsplash.com/photo-1579049643763-639c1126f6d1",
    definition: "Act too soon or before the proper time",
    example: "He jumped the gun and answered before the question was finished.",
    synonyms: ["act prematurely", "rush"]
  },
  {
    word: "On cloud nine",
    image: "https://images.unsplash.com/photo-1523362628745-0c100150b5f2",
    definition: "Extremely happy",
    example: "She was on cloud nine after the wedding.",
    synonyms: ["overjoyed", "ecstatic"]
  }
];
